import { pgTable, serial, text, integer, boolean, timestamp, numeric, jsonb } from "drizzle-orm/pg-core";
import { createInsertSchema } from "drizzle-zod";
import { z } from "zod/v4";

export const vendorProductsTable = pgTable("vendor_products", {
  id: serial("id").primaryKey(),
  vendorId: integer("vendor_id").notNull(),
  name: text("name").notNull(),
  nameAr: text("name_ar"),
  category: text("category").notNull(),
  categoryAr: text("category_ar"),
  description: text("description"),
  descriptionAr: text("description_ar"),
  unit: text("unit").notNull().default("piece"),
  minPrice: numeric("min_price", { precision: 15, scale: 2 }),
  maxPrice: numeric("max_price", { precision: 15, scale: 2 }),
  currency: text("currency").notNull().default("SAR"),
  inStock: boolean("in_stock").notNull().default(true),
  minOrderQty: integer("min_order_qty").notNull().default(1),
  leadTimeDays: integer("lead_time_days"),
  specs: jsonb("specs").$type<Record<string, string>>().default({}),
  imageUrl: text("image_url"),
  tags: jsonb("tags").$type<string[]>().notNull().default([]),
  isActive: boolean("is_active").notNull().default(true),
  createdAt: timestamp("created_at").notNull().defaultNow(),
  updatedAt: timestamp("updated_at").notNull().defaultNow(),
});

export const insertVendorProductSchema = createInsertSchema(vendorProductsTable).omit({ id: true, createdAt: true, updatedAt: true });
export type InsertVendorProduct = z.infer<typeof insertVendorProductSchema>;
export type VendorProduct = typeof vendorProductsTable.$inferSelect;
